import React from "react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import "./yup/customMethods";

import { ApolloProvider } from "@apollo/client";

import client from "./apollo-client/client";
import BadRequestContainer from "./components/BadRequestContainer/BadRequestContainer";
import "./assets/scss/theme.scss";
import "./assets/scss/preloader.scss";
import "react-toastify/dist/ReactToastify.css";
import { injectInterceptor } from "./helpers/api_helper";
import { ThemeProvider } from "./providers";
import RouteLayout from "./routes/RouteLayout";
import { store } from "./store";

injectInterceptor(store);
const App = () => {
  return (
    <Provider store={store}>
      <ThemeProvider>
        <ApolloProvider client={client}>
          <ToastContainer autoClose={5000} />
          <BadRequestContainer />
          <RouteLayout />
        </ApolloProvider>
      </ThemeProvider>
    </Provider>
  );
};
// @ts-ignore
window.store = store;
export default App;
